<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class=" col-12 d-flex justify-content-center align-items-center ">
                        <img [src]="getFirstImage(userData)" alt="user-photo" class="rounded cursor-pointer" height="150" width="150" (click)="open(imageContainer)">
                    </div>
                    <!-- status section-->
                    <div class="col-6 mt-3">
                        <label for="status" class="form-label">Status</label>
                        <input type="text" disabled class="form-control" id="status" value="Pending">
                    </div>
                    <!-- card Number section -->
                    <div class="col-6 mt-3">
                        <label for="card-number" class="form-label">Card Number</label>
                        <input type="text" disabled class="form-control" id="card-number" [value]="userData?.cardNumber">
                    </div>
                    <!-- card expiry date  section -->
                    <div class="col-6 mt-3">
                        <label for="expiry-date" class="form-label">Card Expiry Date</label>
                        <input type="text" disabled class="form-control" id="expiry-date" [value]="userData?.cardValidTo">
                    </div>

                    <div class="col-12 d-flex justify-content-end align-items-center mt-3">
                        <button type="submit" class="btn btn-outline-success mr-2 mb-1" (click)="acceptUser()">Accept</button>
                        <button type="submit" class="btn btn-outline-danger mb-1" (click)="open(rejectModal)">Reject</button>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</div>

<ng-template #rejectModal let-modal>
    <div class="card">
      <div class="card-header bg-light">
        <h4 class="card-title">Reject User Verification Request</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="reason" class="form-label mt-2 font-weight-bold">Reason</label>
              <textarea class="form-control w-100" id="reason" rows="3" placeholder="Reason" [(ngModel)]="rejectionReason"></textarea>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-end align-items-center mt-2">
            <button type="button" class="btn btn-outline-secondary mr-2 mb-1" (click)="Close()">Cancel</button>
            <button type="submit" class="btn btn-outline-danger  mb-1" (click)="Rejection()">Send</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  

  <ng-template #imageContainer let-modal>
    <img [src]="getFirstImage(userData)" class="img-fluid" alt="user-image" >
  </ng-template>